import { render, staticRenderFns } from "./QuestionBank.vue?vue&type=template&id=d27d649a"
import script from "./QuestionBank.vue?vue&type=script&lang=js"
export * from "./QuestionBank.vue?vue&type=script&lang=js"
import style0 from "./QuestionBank.vue?vue&type=style&index=0&id=d27d649a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports